import React from 'react';

function TopHeaderUi({ activeTab, setActiveTab, tabs }) {
	const handleClick = (tabName) => {
		setActiveTab(tabName);
	};

	return (
		<div className="top-header">
			<div className="assets-list">
				<div className="page-title-area pb-2 d-flex align-items-center">
					<img src="/icons/Left-arrow.svg" alt="" className="mr-1 cursor-pointer" />
					<h1 className="semibold-16">UI Components</h1>
				</div>
				<div className="navigation-tab bg-white">
					<ul>
						{tabs.map((item, index) => (
							<li
								key={index}
								className={activeTab === item ? 'active' : ''}
								onClick={() => handleClick(item)}
							>
								{item}
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
}

export default TopHeaderUi;
